import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    register: "/auth/register",
    login: "/auth/login",
    logout: "/auth/logout",
    //
    activate: "/auth/activate",
    resendActivateEmail: "/auth/resend_activate_email",
    //
    forgetPassword: "/auth/forget_password",
    resetPassword: "/auth/reset_password",
    //
    verifyCode: "",
    resendCode: "",
    queryIsEnableRegister: "/web/auth/is_register_enable"
};

// ----------------------------------------------------------------------

const register = (request) => axios.post(API_ENDPOINTS.register, { ...request });

const login = (request) => axios.post(API_ENDPOINTS.login, { ...request });

const logout = () => axios.post(API_ENDPOINTS.logout);

const forgetPassword = (request) => axios.post(API_ENDPOINTS.forgetPassword, { ...request });

const resetPassword = (request) => axios.post(API_ENDPOINTS.resetPassword, { ...request });

const queryIsEnableRegister = () => axios.get(API_ENDPOINTS.queryIsEnableRegister);

const activate = (request) => axios.post(API_ENDPOINTS.activate, { ...request });

const resendActivateEmail = (request) => axios.post(API_ENDPOINTS.resendActivateEmail, { ...request });

const verifyCode = (request) => axios.post(API_ENDPOINTS.verifyCode, { ...request });

const resendCode = (request) => axios.post(API_ENDPOINTS.resendCode, { ...request });


export {
    register as registerAPI,
    login as loginAPI,
    logout as logoutAPI,
    //
    forgetPassword as forgetPasswordAPI,
    resetPassword as resetPasswordJWTAPI,
    //
    activate as activateAPI,
    resendActivateEmail as resendActivateEmailAPI,
    //
    verifyCode as verifyCodeAPI,
    resendCode as resendCodeAPI,
    queryIsEnableRegister as queryIsEnableRegisterAPI
};
